/**
 * What the NautiX generator needs before it publishes a boat — the rule of
 * missingFields() in nautix/lib/render.mjs, so the form can say it before the
 * feed does. The keys are the generator's (`nautix_runs.skipped[].missing`).
 * Change both together.
 */
export type NautixRequirement = 'boat_type' | 'model' | 'price' | 'location_country'

export interface NautixBoatFields {
  boat_type?: string | null
  motorboat_type?: string | null
  model?: string | null
  asking_price?: number | string | null
  location_country?: string | null
}

const text = (value: unknown) =>
  String(value ?? '')
    .trim()
    .toLowerCase()

export function nautixMissing(boat: NautixBoatFields | undefined | null): NautixRequirement[] {
  const missing: NautixRequirement[] = []
  const kind = text(boat?.boat_type)
  // A hovercraft has no NautiX vessel type; the generator skips it.
  const typed =
    kind === 'sailboat' || (kind === 'motorboat' && text(boat?.motorboat_type) !== 'hovercraft')
  if (!typed) missing.push('boat_type')
  if (!text(boat?.model)) missing.push('model')
  const price = Number(boat?.asking_price)
  if (!Number.isFinite(price) || price <= 0) missing.push('price')
  if (!/^[a-z]{2}$/.test(text(boat?.location_country))) missing.push('location_country')
  return missing
}
